<template>
  <div>
    <div id="calendar"></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    // 현재 선택된 날짜
    selectedDate: undefined,
    selectedMonth: undefined,
    passedOrNot: undefined,
    today: undefined,
    challengeStart: undefined,
  }),
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
  },
  methods: {
    async getDateDetail(year, month) {
      this.passedOrNot = undefined;
      // await this.$axios
      //   .get(
      //     "/challenges/" +
      //       this.challengeId +
      //       "/calendar?year=" +
      //       year +
      //       "&month=" +
      //       month
      //   )
      //   .then((response) => {
      //     this.passedOrNot = response.data;
      //   });
      this.passedOrNot = [
        {
          challenge_date: "2023-08-01",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-02",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-03",
          is_passed: false,
        },
        {
          challenge_date: "2023-08-04",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-05",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-06",
          is_passed: false,
        },
        {
          challenge_date: "2023-08-07",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-08",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-09",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-10",
          is_passed: true,
        },
        {
          challenge_date: "2023-08-11",
          is_passed: true,
        },
      ]
    },
    getToday() {
      var today = new Date();
      var dd = String(today.getDate());
      var mm = String(today.getMonth() + 1);
      mm = mm >= 10 ? mm : "0" + mm;
      dd = dd >= 10 ? dd : "0" + dd;
      var yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd + "";

      this.today = today;
      var selectedDate = window.sessionStorage.getItem("selectedDate");
      if (selectedDate) {
        this.selectedDate = selectedDate;
      } else {
        this.selectedDate = today;
      }
    },
    async makeCalendar(element, date) {
      var vm = this;
      let nowDate = new Date();
      if (date == null || date == undefined) {
        var selectedDate = window.sessionStorage.getItem("selectedDate");
        if (selectedDate) {
          date = new Date(selectedDate);
        } else {
          date = new Date();
        }
      }
      nowDate = date;
      const year = nowDate.getFullYear(),
        month = nowDate.getMonth() + 1;
      document.querySelector(element).innerHTML = calendarTable(year, month);

      const thisMonth = new Date(year, month - 1, 1),
        thisLastDay = new Date(year, month, 0);

      if (vm.selectedMonth !== month) {
        vm.selectedMonth = month;
        await vm.getDateDetail(year, month);
      }
      let tag = "<div>";
      let cnt = 0;
      for (let i = 0; i < thisMonth.getDay(); i++) {
        tag += "<span></span>";
        cnt++;
      }

      for (let i = 1; i <= thisLastDay.getDate(); i++) {
        if (cnt % 7 == 0) {
          if (i == 1) {
            tag += "";
          } else {
            tag += "<div>";
          }
        }

        tag += `<span>${i}</span>`;
        cnt++;

        if (cnt % 7 == 0) {
          tag += "</div>";
        }
      }
      if (thisLastDay.getDate()) {
        for (let i = 0; i < 7 - (cnt % 7); i++) {
          tag += "<span></span>";
        }
      }

      document
        .querySelector(element)
        .querySelector(".calendarTableDay").innerHTML = tag;

      function calendarTable(year, month) {
        const calendarHtml = `
          <div class="calendarTable">
            <div class="calendarTableTop">
              <button class="calendarTableButton prev">이전</button>
              <div class="yymm">
                <span class="yy">${year}</span>.
                <span class="mm">${month}</span>
              </div>
              <button class="calendarTableButton next">다음</button>
            </div>
            <div class="calendarTableWeek">
              <span>SUN</span>
              <span>MON</span>
              <span>TUE</span>
              <span>WEN</span>
              <span>THU</span>
              <span>FRI</span>
              <span>SAT</span>
            </div>
            <div class="calendarTableDay"></div>
          </div>
        `;
        return calendarHtml;
      }

      document
        .querySelector(".calendarTableButton.prev")
        .addEventListener("click", () => {
          nowDate = new Date(
            nowDate.getFullYear(),
            nowDate.getMonth() - 1,
            nowDate.getDate()
          );
          this.makeCalendar(element, nowDate);
        });
      document
        .querySelector(".calendarTableButton.next")
        .addEventListener("click", () => {
          nowDate = new Date(
            nowDate.getFullYear(),
            nowDate.getMonth() + 1,
            nowDate.getDate()
          );
          this.makeCalendar(element, nowDate);
        });

      const days = document
        .querySelector(".calendarTableDay")
        .querySelectorAll("span");

      days.forEach(function (element, i) {
        const nowYear = nowDate.getFullYear(),
          nowMonth = nowDate.getMonth() + 1;
        var yyyy = nowYear.toString();
        var mm = nowMonth;
        var dd = element.textContent;
        mm = mm >= 10 ? mm : "0" + mm;
        dd = dd >= 10 ? dd : "0" + dd;
        var today = yyyy + "-" + mm + "-" + dd + "";

        element.id = today;

        if (
          dd == 0 ||
          element.id > vm.today ||
          element.id < vm.challengeStart
        ) {
          element.style.color = "#ccc";
        }


        element.addEventListener("click", function () {
          if (
            dd == 0 ||
            element.id > vm.today ||
            element.id < vm.challengeStart
          ) {
            return false;
          } else {
            vm.selectedDate = today;
            days.forEach((element) => element.classList.remove("active"));
            this.classList.add("active");
          }
        });
      });

      const todayYear = new Date().getFullYear();
      let todayMonth = new Date().getMonth() + 1,
        todayDate = new Date().getDate();
      todayMonth = todayMonth >= 10 ? todayMonth : "0" + todayMonth;
      todayDate = todayDate >= 10 ? todayDate : "0" + todayDate;

      const nowToday = `${todayYear}-${todayMonth}-${todayDate}`;

      if (document.getElementById(nowToday)) {
        document.getElementById(nowToday).classList.add("today");
        //today 표시
        const todayElement = document.createElement('span');
        todayElement.className = 'todayCircle';
        document.querySelector('.today').append(todayElement);
      }

      vm.passedOrNot.forEach((element) => {
        if (element.is_passed === true) {
          document
            .getElementById(element.challenge_date)
            .classList.add("passed");
        } else {
          document
            .getElementById(element.challenge_date)
            .classList.add("reject");
        }
      });
    },
    syncDate() {
      var selectedDate = window.sessionStorage.getItem("selectedDate");
      if (selectedDate) {
        this.selectedDate = selectedDate;
        document.getElementById(selectedDate).click();
      }
    },
  },
  watch: {
    selectedDate(v) {
      this.selectedMonth = parseInt(v.split("-")[1]);
      window.sessionStorage.setItem("selectedDate", v);
      this.$emit("dateChanged", v);
    },
  },
  async mounted() {
    // await this.$axios
    //   .get("/challenges/" + this.challengeId)
    //   .then((response) => {
    //     this.challengeStart = response.data.challenge_start;
    //   });
    this.challengeStart = "2023-08-01";

    await this.getToday();
    await this.getDateDetail(
      this.selectedDate.split("-")[0],
      this.selectedDate.split("-")[1]
    );
    await this.makeCalendar("#calendar", null);
    await this.syncDate();
  },
};
</script>
<style lang="scss">
#calendar {
  .calendarTable {
    .calendarTableTop {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #FFB5CC;
      font-size: 24px;
      overflow: hidden;

      .calendarTableButton {
        width: 7px;
        height: 14px;
        background: url("../../assets/images/common/icon_arrow.svg") no-repeat
          center center;
        text-indent: -9999px;

        &.next {
          transform: scaleX(-1);
        }
      }
    }
    .calendarTableWeek {
      padding-bottom: 8px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      color: #ccc;
      text-align: center;

      > span {
        width: 40px;
      }
    }
    .calendarTableDay {
      border-bottom: 1px solid #ccc;

      > div {
        display: flex;
        justify-content: space-between;
        color: #555;
        text-align: center;

        > span {
          width: 40px;
          margin: 4px;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          &::after {
            content: "";
            display: block;
            padding-bottom: 100%;
          }
          &.today {
            color: #FFB5CC;
            border: 1px solid #FFB5CC;
            position: relative;

            .todayCircle{
              width: 4px;
              height: 4px;
              border-radius: 100%;
              position: absolute;
              top: -2px;
              left: -2px;
              background-color: #b5b5b5;
            }
          }
          &.passed {
            border-color: #ffdc25;
            text-indent: -9999px;
            background: url("../../assets/images/common/icon_check.svg")
              no-repeat center center #ffdc25;
          }
          &.reject {
            border-color: #ce0c0c;
            text-indent: -9999px;
            background: url("../../assets/images/common/icon_reject.svg")
              no-repeat center center #ce0c0c;
          }
          &.active {
            color: #fff;
            text-indent: 0;
            border-color: #FFB5CC;
            background-color: #FFB5CC;
            background-image: none;

            .todayCircle{
              background-color: #FFB5CC;
            }
          }
        }
      }
    }
  }
}
</style>